/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_legal_link__credits = /** @type {(inputs: {}) => string} */ () => {
	return `Impressum`
};

const en_legal_link__credits = /** @type {(inputs: {}) => string} */ () => {
	return `Credits`
};

const es_legal_link__credits = /** @type {(inputs: {}) => string} */ () => {
	return `Créditos`
};

const fr_legal_link__credits = /** @type {(inputs: {}) => string} */ () => {
	return `Crédits`
};

const it_legal_link__credits = /** @type {(inputs: {}) => string} */ () => {
	return `Crediti`
};

const nl_legal_link__credits = /** @type {(inputs: {}) => string} */ () => {
	return `Credits`
};

const pt_legal_link__credits = /** @type {(inputs: {}) => string} */ () => {
	return `Créditos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__credits = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.legal_link__credits(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("legal_link__credits", locale)
	if (locale === "de") return de_legal_link__credits(inputs)
	if (locale === "en") return en_legal_link__credits(inputs)
	if (locale === "es") return es_legal_link__credits(inputs)
	if (locale === "fr") return fr_legal_link__credits(inputs)
	if (locale === "it") return it_legal_link__credits(inputs)
	if (locale === "nl") return nl_legal_link__credits(inputs)
	return pt_legal_link__credits(inputs)
};